import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import SmartUpload from './pages/SmartUpload';
import Scanner from './pages/Scanner';
import Expenses from './pages/Expenses';
import Export from './pages/Export';
import BOLSend from './pages/BOLSend';
import Settings from './pages/Settings';
import ImportSettlement from './pages/ImportSettlement';
import ImportComdata from './pages/ImportComdata';
import ImportTravel from './pages/ImportTravel';
import ImportBankStatement from './pages/ImportBankStatement';
import TripCalendar from './pages/TripCalendar';
import TransactionMatcher from './pages/TransactionMatcher';
import TaxSummary from './pages/TaxSummary';
import Reports from './pages/Reports';
import BulkStorage from './pages/BulkStorage';
import Loadboard from './pages/Loadboard';
import DebugData from './pages/DebugData';
import AuditReview from './pages/AuditReview';
import IncomeAudit from './pages/IncomeAudit';
import Coverage from './pages/Coverage';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/debug-data" element={<DebugData />} />
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute><Layout><Upload /></Layout></ProtectedRoute>} />
      <Route path="/smart-upload" element={<ProtectedRoute><Layout><SmartUpload /></Layout></ProtectedRoute>} />
      <Route path="/scanner" element={<ProtectedRoute><Layout><Scanner /></Layout></ProtectedRoute>} />
      <Route path="/bol-send" element={<ProtectedRoute><Layout><BOLSend /></Layout></ProtectedRoute>} />
      <Route path="/loadboard" element={<ProtectedRoute><Layout><Loadboard /></Layout></ProtectedRoute>} />
      <Route path="/expenses" element={<ProtectedRoute><Layout><Expenses /></Layout></ProtectedRoute>} />
      <Route path="/export" element={<ProtectedRoute><Layout><Export /></Layout></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><Layout><ImportSettlement /></Layout></ProtectedRoute>} />
      <Route path="/import-fuel" element={<ProtectedRoute><Layout><ImportComdata /></Layout></ProtectedRoute>} />
      <Route path="/import-travel" element={<ProtectedRoute><Layout><ImportTravel /></Layout></ProtectedRoute>} />
      <Route path="/import-bank" element={<ProtectedRoute><Layout><ImportBankStatement /></Layout></ProtectedRoute>} />
      <Route path="/bulk-storage" element={<ProtectedRoute><Layout><BulkStorage /></Layout></ProtectedRoute>} />
      <Route path="/trips" element={<ProtectedRoute><Layout><TripCalendar /></Layout></ProtectedRoute>} />
      <Route path="/matcher" element={<ProtectedRoute><Layout><TransactionMatcher /></Layout></ProtectedRoute>} />
      <Route path="/tax" element={<ProtectedRoute><Layout><TaxSummary /></Layout></ProtectedRoute>} />
      <Route path="/audit" element={<ProtectedRoute><Layout><AuditReview /></Layout></ProtectedRoute>} />
      <Route path="/income-audit" element={<ProtectedRoute><Layout><IncomeAudit /></Layout></ProtectedRoute>} />
      <Route path="/coverage" element={<ProtectedRoute><Layout><Coverage /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;






